export default __webpack_public_path__ + "static/media/cablestar.4f301edc.png";